
import axios from 'axios';

const jwt = localStorage.getItem('@mob:jwt');

const api = axios.create({
    //baseURL: 'http://localhost/_mob/api21/',
    baseURL: 'https://api3.metodobillings.com.br/',
    timeout: 15000,
    headers: {         
        'Authorization': 'Bearer '+ jwt,
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
})

// Set the AUTH token for any request
api.interceptors.request.use(function (config) {    
    const jwt = localStorage.getItem('@mob:jwt');
    config.headers.Authorization =  jwt ? `Bearer ${jwt}` : '';
    return config;
});

export {api};
